import { css } from 'styled-components';

const maxSizes = {
  lg: 1919,
  md: 1279,
  sm: 959,
  xs: 639,
};
const minSizes = {
  lg: 1920,
  md: 1280,
  sm: 960,
  xs: 640,
};

// Iterate through the sizes and create a media template
export const max = Object.keys(maxSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${maxSizes[label] / 16}em) {
      ${css(...args)};
    }
  `;

  return acc;
}, {});

export const min = Object.keys(minSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${minSizes[label] / 16}em) {
      ${css(...args)};
    }
  `;

  return acc;
}, {});

